import '../sass/style.scss';

import './modules/ua-sniffing.js';

import navigation from './modules/navigation.js';
import homeFeatures from './modules/home-features.js';
import villaLists from './modules/villas.js';
import villaPage from './modules/villa.js';
import mediaPlayers from './modules/mediaplayer.js';
import mediaBrowser from './modules/media-browser.js';
import formHandler from './modules/form-handler.js';
import numberscroll from './modules/numberscroll.js';
import gallerySlideshow from './modules/gallery-slideshow.js';
import twitterFeed from './modules/twitter-feed.js';

navigation();
homeFeatures();
villaLists();
villaPage();
mediaPlayers();
mediaBrowser();
formHandler();
numberscroll();
gallerySlideshow();
twitterFeed();




// WEBPACK FOOTER //
// ./public/javascripts/app.js